








































import { defineComponent, ref, computed, PropType } from '@vue/composition-api';

const name = 'ttam-tracking-background-container';

enum Mode {
  focus = 'focus',
  edit = 'edit',
}
type Option = {
  label: string;
  value?: string;
  icon?: string;
};
export default defineComponent({
  name,
  props: {
    focusClass: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    options: {
      type: Array as PropType<Option[]>,
      default: () => [],
    },
  },
  setup() {
    const mode = ref<Mode>(Mode.focus);
    const isFocus = computed(() => mode.value === Mode.focus);
    const handleClickEdit = () => {
      mode.value = Mode.edit;
    };

    return {
      mode,
      name,
      isFocus,
      handleClickEdit,
    };
  },
});
